import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { searchPeople } from "../../apis/ext";

export const useSearchPeopleByIds = (ids = [], workspaceId) => {
  const [profilesMap, setProfilesMap] = useState({});

  const mutation = useMutation(
    ({ ids, headers }) =>
      searchPeople({
        data: { query: { ids } },
        options: { headers },
      }),
    {
      onSuccess: (response) => {
        const enrichedArray = response?.data || [];

        setProfilesMap((prev) => {
          const updated = { ...prev };
          enrichedArray.forEach((person) => {
            if (person && person.contacts?.length === 0) {
              person.enrichment_lists = [];
            }
            if (person?.contacts?.length > 0) {
              person.contact_id = person.contacts[0]?.id;
              person.enrichment_lists = person.contacts[0].enrichment_lists;
            }
            person.person_id = person.id;
            person.linkedin_url = person.linkedin_urls?.[0] || "";
            updated[person.id] = person;
          });
          return updated;
        });
      },
      onError: (error) => {
        console.error("Error fetching enriched profiles:", error);
      },
    }
  );

  // Auto-fetch unfetched IDs
  useEffect(() => {
    const unfetchedIds = ids.filter((id) => !profilesMap[id]);

    if (unfetchedIds.length > 0 && workspaceId) {
      mutation.mutate({
        ids: unfetchedIds,
        headers: { "X-Workspace-Id": workspaceId },
      });
    }
  }, [ids, workspaceId]);

  // Manual refetch function
  const refetch = () => {
    if (ids.length > 0 && workspaceId) {
      mutation.mutate({
        ids,
        headers: { "X-Workspace-Id": workspaceId },
      });
    }
  };

  const people = ids.map((id) => profilesMap[id]).filter(Boolean);
  const clearProfiles = () => {
    setProfilesMap({});
  };

  return {
    people,
    isLoading: mutation.isLoading,
    error: mutation.error,
    refetch, // <== Expose this
    clearProfiles,
  };
};
